import { render, staticRenderFns } from "./liveContent.vue?vue&type=template&id=6b36423e&scoped=true"
import script from "./liveContent.vue?vue&type=script&lang=js"
export * from "./liveContent.vue?vue&type=script&lang=js"
import style1 from "./liveContent.vue?vue&type=style&index=1&id=6b36423e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b36423e",
  null
  
)

export default component.exports